
export const listenToStore = (listenerStore, store, callback) => {
  if (!listenerStore.listenTo) {
    console.warn('Not instance of event emitter', store)
  }
  listenerStore.listenTo(store, callback) // Subscribe to future updates
  const initialState = store.getInitialState() || {}
  callback(initialState)
}